import { render, staticRenderFns } from "./RelatorioAcompanhamentoCampanhaAds.vue?vue&type=template&id=650a02e6"
import script from "./RelatorioAcompanhamentoCampanhaAds.vue?vue&type=script&lang=js"
export * from "./RelatorioAcompanhamentoCampanhaAds.vue?vue&type=script&lang=js"
import style0 from "./RelatorioAcompanhamentoCampanhaAds.vue?vue&type=style&index=0&id=650a02e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports